import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useInventoryNoteList(params) {
  return useSWR(
    !!params?.warehouse
      ? {
          path: `/api/v1/inventory-notes`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useInventoryNoteList;
